<template>
  <div class="sessions">
    <Management
      :title="$t('scheduler.session.name-plural')"
      :fields="fields"
      :data="sessions"
      :loading="loading"
      sort="modification"
      inspect-route="/sessions/"
      create-route="/create/session"
    ></Management>
  </div>
</template>

<script>
import Management from "@/components/utilities/Management";
import adaptersIn from "@/services/data-adapter/incoming/scheduler";

export default {
  components: {
    Management
  },
  data() {
    return {
      loading: true,
      sessions: []
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "code",
          text: this.$t("scheduler.session.fields.code"),
          sortable: true
        },
        {
          name: "description",
          text: this.$t("scheduler.session.fields.description"),
          sortable: true
        },
        {
          name: "size",
          text: this.$t("scheduler.session.fields.size"),
          sortable: true
        }
      ];
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getSessions();
    });
  },
  methods: {
    getSessions() {
      var self = this;
      this.loading = true;

      var requestSuccessful = function(req) {
        if (!req.data.events_groups) {
          return;
        }
        adaptersIn.sessions(req.data.events_groups).then(res => {
          self.sessions = res;
          self.loading = false;
        });
      };

      // eslint-disable-next-line no-unused-vars
      var requestFailed = function(error) {
        if (self.sessions) {
          self.sessions = [];
        }
        self.$store.dispatch(
          "system/setStatus",
          {
            type: "error",
            message: "Could not retrieve sessions information."
          },
          { root: true }
        );
      };

      return this.$http
        .get("/eventsgroups?trashed=1")
        .then(request => requestSuccessful(request))
        .catch(error => requestFailed(error));
    }
  }
};
</script>
